import { render, staticRenderFns } from "./accounting-reports-page.vue?vue&type=template&id=14159077&scoped=true&"
import script from "./accounting-reports-page.vue?vue&type=script&lang=ts&"
export * from "./accounting-reports-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14159077",
  null
  
)

export default component.exports